<template>
  <b-card class="text-center p-2">
    <router-link class="h3" :to="to">
      {{ label }}
    </router-link>
  </b-card>
</template>
<script>
export default {
  props: {
    to: {
      type: Object
    },

    label: {
      default: undefined
    }
  }
};
</script>
